<template>
  <div class="qmyx-container">
    <div class="inviter-info" v-if="invited">推荐人：{{ introAgentName }}</div>
    <div v-if="!auth.status" class="list am-form-horizontal">
      <div class="list-item sep">
        <img
          src="https://assets.rurushishi.com/yq-rs-make/huafa/img/tel.png"
          class="icon"
        />
        <input
          v-model="phone"
          type="tel"
          class="flex1 stretch"
          placeholder="请输入手机号"
        />
      </div>
      <div class="list-item sep">
        <img
          src="https://assets.rurushishi.com/yq-rs-make/huafa/img/code.png"
          class="icon"
        />
        <input
          v-model="code"
          type="number"
          placeholder="请输入验证码"
          class="flex1 stretch"
        />
        <button
          class="btn-warning code"
          :class="{ reset: sending }"
          @click="handleSendCode"
        >
          {{ !sending ? "获取验证码" : `重发(${second})s` }}
        </button>
      </div>
      <div class="list-item protocol-wrap">
        <img
          v-if="protocol"
          src="https://assets.rurushishi.com/yq-rs-make/huafa/img/selected.png"
          class="icon"
          @click="protocol = false"
        />
        <img
          v-else
          src="https://assets.rurushishi.com/yq-rs-make/huafa/img/select-default.png"
          class="icon"
          @click="protocol = true"
        />
        <label class="flex1 protocol" for="clause">
          <span>本人已亲自阅读并同意</span>
          <span class="text-warning" @click="handleReadAgreement"
            >《用户注册协议》</span
          >
          <span>，完全理解和接受所有涉及本人权利义务的约定。</span>
        </label>
      </div>
      <button class="submit-btn btn" @click="handleSubmit">
        提交
      </button>
    </div>
    <div v-else class="auth-success">
      <img
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/success.png"
        class="auth-img"
        @click="protocol = true"
      />
      <div class="auth-title">认证成功</div>
      <div class="auth-desc">您当前的经纪人身份为【{{ auth.name }}】</div>
      <div class="auth-desc">如需更改身份请继续完善个人信息</div>

      <div class="btn-wrap">
        <button class="submit-btn btn" @click="handleCompeleDetail">
          完善信息
        </button>
        <button class="btn" @click="handleSkipDetail">
          跳过
        </button>
      </div>
      <div class="qrCode-wrapper">
        <img src="https://assets.rurushishi.com/hf/hf_qr.jpg" class="qrCode" />
      </div>
      <div class="qrCode-tag">扫码关注“华发置业通”</div>
    </div>
    <tabbar7 v-if="!invited" />
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { getCode, newSubmitVer } from "./api";
import { getAgent } from "../api";
import Cookies from "js-cookie";
import { Indicator } from "mint-ui";
const Tabbar7 = () => import("@/components/tabbar7");

let timer = null; // 倒计时timer
export default {
  name: "AgentAuth",
  components: {
    Tabbar7
  },
  data() {
    return {
      auth: {
        status: false, // 认证状态
        name: "xxx" // 认证人姓名
      }, // 当前认证状态
      toast: "验证码已发送",
      phone: "",
      code: "", // 验证码
      sending: false, // 是否发送短信验证码中
      second: 60,
      protocol: false, // 是否同意用户协议
      invited: false,
      introAgentId: "",
      introAgentName: ""
    };
  },
  methods: {
    phoneValid() {
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast("请填写正确的手机号");
        return false;
      }
      return true;
    },
    handleValid() {
      if (!this.phoneValid()) {
        return false;
      }
      if (!this.code) {
        Toast("请输入短信验证码");
        return false;
      }
      if (!this.protocol) {
        Toast("请同意《用户注册协议》");
        return false;
      }
      return true;
    },
    resetSend() {
      this.closeTimer();
      this.second = 60;
      this.sending = false;
    },
    closeTimer() {
      clearInterval(timer);
      timer = null;
    },
    async handleSendCode() {
      if (!this.phoneValid()) {
        return;
      }
      if (this.sending) return;
      this.sending = true;
      console.log("发送验证码");
      try {
        Indicator.open();
        const { code = "", msg = "下发失败" } = await getCode(this.phone);
        Indicator.close();
        if (code === "200") {
          Toast("验证码已发送");
          this.closeTimer();
          timer = setInterval(() => {
            if (this.second === 0) {
              this.resetSend();
              return;
            }
            this.second--;
          }, 1000);
        } else {
          Toast(msg);
          this.resetSend();
        }
      } catch (error) {
        Indicator.close();
        this.resetSend();
      }
    },
    async handleSubmit() {
      const result = this.handleValid();
      let cityId = JSON.parse(Cookies.get("t9_20200131_init")).id;
      if (!result) return;
      let params;
      // params = {
      //   agentTel: this.phone,
      //   verCode: this.code,
      //   owxOpenId: Cookies.get("openid")
      // };
      params = {
        telPhone: this.phone,
        verCode: this.code,
        cityOpenId: Cookies.get("openid"),
        cityId
      };
      if (this.invited) {
        params.introducerAgent = this.introAgentId;
      }
      try {
        Indicator.open();
        const { code, msg } = await newSubmitVer(params);
        Indicator.close();
        if (code !== "200") {
          return Toast(msg);
        }
        await this.handleGetAgent();
        document.title = "经纪人认证成功";
        this.auth.status = true;
      } catch (error) {
        console.log(JSON.stringify(error));
        Toast(error.response.data.msg);
        this.resetSend();
        Indicator.close();
      }
    },
    async handleGetAgent() {
      const { status } = await getAgent();
      // 50 拓客团队，10 全民经纪人， 40 华发员工， 30 华发业主
      const statusMap = {
        "10": "全民经纪人",
        "30": "华发业主",
        "40": "华发员工",
        "50": "拓客团队"
      };
      this.auth.name = statusMap[status];
    },
    handleCompeleDetail() {
      this.$router.push({
        name: "certification"
      });
    },
    handleReadAgreement() {
      this.$router.push({
        name: "user-agreement"
      });
    },
    handleSkipDetail() {
      this.$router.push({
        name: "client-backup"
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === "check-agent") {
        vm.invited = true;
        vm.introAgentId = vm.$route.params.introAgentId;
        vm.introAgentName = vm.$route.params.introAgentName;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.qrCode-wrapper {
  width: fit-content;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.2rem;
  border: 1px solid #ddd;
  border-radius: 0.16rem;
  .qrCode {
    width: 2.5rem;
    height: 2.5rem;
  }
}
.qrCode-tag {
  height: 0.4rem;
  line-height: 0.4rem;
  text-align: center;
  margin: 0.16rem auto 2rem;
  font-size: 0.28rem;
  color: #999;
}
.inviter-info {
  margin: 0.38rem 0.44rem 0rem;
  font-size: 0.28rem;
  color: #333;
}
.list {
  .code {
    background: #f07b24;
    border-radius: 0.3rem;
    color: #ffffff;
    font-size: 0.28rem;
    padding: 0.08rem 0.24rem;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    &.reset {
      background: #bbbbbb;
    }
  }
  .protocol-wrap {
    margin-top: 0.8rem;
    .protocol {
      font-size: 0.28rem;
      color: #999999;
      line-height: 1.5;
      .text-warning {
        color: #f07b24;
      }
    }
  }

  .submit-btn {
    margin-top: 0.4rem;
  }
}
.auth-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  .auth-img {
    width: 0.96rem;
    height: 0.96rem;
    margin-top: 1.88rem;
    margin-bottom: 0.32rem;
  }
  .auth-title {
    font-size: 0.36rem;
    color: #222222;
    margin-bottom: 0.6rem;
  }
  .auth-desc {
    font-size: 0.3rem;
    color: #222222;
    padding-bottom: 0.16rem;
  }
  .btn-wrap {
    margin-top: 1.2rem;
    display: flex;
    align-items: center;
    .btn {
      background: #bbbbbb;
      border-radius: 0.16rem;
      border-radius: 0.16rem;
      width: 2.76rem;
      font-size: 0.36rem;
      padding: 0.2rem 0;
      color: #ffffff;
      &.submit-btn {
        background: #f07b24;
      }
      &:nth-child(2) {
        margin-left: 0.48rem;
      }
    }
  }
}
</style>
